import styled from '@emotion/styled/macro';
import { colors } from '../../styles/theme.styles';

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 24px;
  border-bottom: 1px solid ${colors.lightGray2};
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  font-family: Circular;
  color: ${colors.darkGray1};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  height: 100%;
  overflow-y: auto;
`;

export const Illustration = styled.div`
  height: 80px;
  width: 80px;
  svg {
    width: 80px;
    height: 80px;
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.darkGray1};
  margin-bottom: 24px;
  text-align: center;
  max-width: 340px;
`;

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1A1B1D;
  color: #fff;
  border: none;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  width: 100%;
  max-width: 320px;
  cursor: pointer;
  gap: 8px;
  transition: background 0.2s;
  &:hover {
    background: #333;
  }
`;

export const SecuredBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.darkGray1};
  padding: 20px 24px;
  font-size: 14px;
  gap: 6px;
`; 